import type { SanityPageBuilderHeadlineBSection, SanityPageBuilderSection } from "@ouster/shared";
import { HeadlineBBlockView } from "~/features/blocks/inventory/headline-b";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderHeadlineBSection;
  };
};
export function SanityHeadlineBSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  return <HeadlineBBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} hasSolidBackground={sectionContent.hasSolidBackground} hasSpacer={sectionContent.hasSpacer} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isHighlighted={sectionContent.isHighlighted} link={toCraftLinkArray(sectionContent.link)} linkVariant={sectionContent.linkVariant} mainHeadline={sectionContent.headline} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} />;
}